module.exports = __webpack_public_path__ + "json/buildings-11.json?61af04b155898ebc346b96ce16a6fcfa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-11.json
// module id = 1717
// module chunks = 3